/* models/modal.js */ function _(require, module, exports, __esModule, __esExport) {
    var _a, _b;
    __esModule();
    const tslib_1 = require("tslib");
    var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if (d = decorators[i])
                    r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var ModalDialogEvent_1;
    const column_1 = require("@bokehjs/models/layouts/column");
    const dom_1 = require("@bokehjs/core/dom");
    const bokeh_events_1 = require("@bokehjs/core/bokeh_events");
    const ui_element_1 = require("@bokehjs/models/ui/ui_element");
    const types_1 = require("@bokehjs/core/util/types");
    const modal_css_1 = tslib_1.__importDefault(require("be4b4352c6") /* ../styles/models/modal.css */);
    let ModalDialogEvent = (_a = class ModalDialogEvent extends bokeh_events_1.ModelEvent {
        constructor(model, open) {
            super();
            this.model = model;
            this.open = open;
            this.open = open;
            this.origin = model;
        }
        get event_values() {
            return { open: this.open, origin: this.origin };
        }
        static from_values(values) {
            const { open, model } = values;
            return new ModalDialogEvent_1(model, open);
        }
    },
        (() => {
            ModalDialogEvent_1 = _a;
        })(),
        _a.__name__ = "ModalDialogEvent",
        _a);
    exports.ModalDialogEvent = ModalDialogEvent;
    exports.ModalDialogEvent = ModalDialogEvent = ModalDialogEvent_1 = __decorate([
        (0, bokeh_events_1.server_event)("modal-dialog-event")
    ], ModalDialogEvent);
    class ModalView extends column_1.ColumnView {
        connect_signals() {
            super.connect_signals();
            const { show_close_button } = this.model.properties;
            this.on_change([show_close_button], this.update_close_button);
            this.model.on_event(ModalDialogEvent, (event) => {
                event.open ? this.modal.show() : this.modal.hide();
            });
        }
        render() {
            ui_element_1.UIElementView.prototype.render.call(this);
            this.class_list.add(...this.css_classes());
            this.create_modal();
        }
        stylesheets() {
            return [...super.stylesheets(), modal_css_1.default];
        }
        // Route child views into the dialog content container instead of
        // shadow_el. The inherited update_children() matching optimization
        // scans shadow_el.children so it won't find existing modal children,
        // but this is harmless for the small number of children a modal holds.
        get self_target() {
            return this.content ?? this.shadow_el;
        }
        create_modal() {
            const dialog = (0, dom_1.div)({
                id: "pnx_dialog",
                class: "dialog-container bk-root",
                style: { display: "none" },
            });
            const dialog_overlay = (0, dom_1.div)({ class: "dialog-overlay" });
            if (this.model.background_close) {
                dialog_overlay.setAttribute("data-a11y-dialog-hide", "");
            }
            const { height, width, min_height, min_width, max_height, max_width } = this.model;
            const content = (0, dom_1.div)({
                id: "pnx_dialog_content",
                class: "dialog-content",
                role: "document",
                style: {
                    height: (0, types_1.isNumber)(height) ? `${height}px` : height,
                    width: (0, types_1.isNumber)(width) ? `${width}px` : width,
                    min_height: (0, types_1.isNumber)(min_height) ? `${min_height}px` : min_height,
                    min_width: (0, types_1.isNumber)(min_width) ? `${min_width}px` : min_width,
                    max_height: (0, types_1.isNumber)(max_height) ? `${max_height}px` : max_height,
                    max_width: (0, types_1.isNumber)(max_width) ? `${max_width}px` : max_width,
                    overflow: "auto",
                },
            });
            this.content = content;
            for (const child_view of this.child_views) {
                const target = child_view.rendering_target() ?? this.content;
                child_view.render_to(target);
            }
            this.close_button = (0, dom_1.button)({
                id: "pnx_dialog_close",
                "data-a11y-dialog-hide": "",
                class: "pnx-dialog-close",
                ariaLabel: "Close this dialog window",
            });
            this.close_button.innerHTML = "&#x2715";
            dialog.append(dialog_overlay);
            dialog.append(content);
            content.append(this.close_button);
            this.shadow_el.append(dialog);
            let first_open = false;
            this.modal = new A11yDialog(dialog);
            this.update_close_button();
            this.modal.on("show", () => {
                this.model.open = true;
                dialog.style.display = "";
                if (!first_open) {
                    requestAnimationFrame(() => { this.invalidate_layout(); dialog.focus(); });
                    first_open = true;
                }
            });
            this.modal.on("hide", () => {
                this.model.open = false;
                dialog.style.display = "none";
            });
            if (this.model.open) {
                this.modal.show();
            }
        }
        update_close_button() {
            if (this.model.show_close_button) {
                this.close_button.style.display = "block";
            }
            else {
                this.close_button.style.display = "none";
            }
        }
    }
    exports.ModalView = ModalView;
    ModalView.__name__ = "ModalView";
    class Modal extends column_1.Column {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.Modal = Modal;
    _b = Modal;
    Modal.__name__ = "Modal";
    Modal.__module__ = "panel.models.modal";
    (() => {
        _b.prototype.default_view = ModalView;
        _b.define(({ Bool }) => ({
            open: [Bool, false],
            show_close_button: [Bool, true],
            background_close: [Bool, true],
        }));
    })();
}
